import React from "react";
import { observer } from "mobx-react";
import { useState, useEffect } from "react";
import { Modal, Button, Form, Tab, Tabs, Col, Row } from "react-bootstrap";
import CloseImg from "../../Assets/Modal-Assets/Close.png";
import "../../../src/global.css";
import LinearProgress from "@mui/material/LinearProgress";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import fileupload from "../../Assets/images/fileupload.png";
import "./index.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { TextField } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import JSZip from "jszip";
const MatchFieldsModal = observer(
  ({
    rootStore,
    fileInputRef,
    fieldOptions,
    typeOptions,
    uploadFileDetails,
    setUploadFileDetails,
    handleFileChange,
    formStatusNegativeAlert,
    setFormStatusNegativeAlert,
    handleInClusionExclusionSubMission,
    selectedValues,
    setSelectedValues,
    options,
    setOptions,
  }) => {
    const handleNext = () => {
      rootStore.setModalStep(rootStore.modalStep + 1);
    };
    const handlePrevious = () => {
      rootStore.setModalStep(rootStore.modalStep - 1);
    };
    const handleFormSubmit = (e) => {
      e.preventDefault();
      const selectedKeys = Object.values(selectedValues).filter(
        (val) => val !== ""
      );
      const isFormValid = selectedKeys.length >= 2;
      if (!isFormValid) {
        setFormStatusNegativeAlert(true);
      } else {
        handleInClusionExclusionSubMission();
      }
    };
    const download = () => {
      const csvContent = `"Company name","URN","Address line 1","Address line 2","Post code","Register number",
"TechCorp","URN123456","123 Main St","New York, NY","10001","223",
"BizGroup","URN654321","456 Elm Ave","Los Angeles, CA","90001","335",
"InnoSoft","URN112233","789 Oak Blvd","Chicago, IL","60601","888"
"reWare","URN998877","321 Pine Rd","San Jose, CA","95101","880",
"FinTechZone","URN443322","22 Wall St","New York, NY","10005","556",
"HealthCore","URN556677","88 Wellness Dr","Houston, TX","77001","557",
"EduVerse","URN334455","99 Knowledge Ln","Boston, MA","02101","44646",
"GreenLogix","URN778899","11 Eco Park","Portland, OR","97201","67600",`;
      const blob = new Blob([`\uFEFF${csvContent}`], {
        type: "text/csv;charset=utf-8;",
      });
      saveAs(blob, "Sample_Data.csv");
    };
    const fieldSelect = [
      { label: "Company Name", value: "company_name" },
      { label: "URN (Experian)", value: "urn" },
      { label: "Address Line 1", value: "addressline1" },
      { label: "Address Line 2", value: "addressline2" },
      { label: "Post Code", value: "postcode" },
      { label: "Company Register Number", value: "crn" },
    ];
    //   const handleFileChange = async (e, type) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //       // rootStore.setImportType(type);
    //       await rootStore.processFile(file);
    //     }
    //   };
    useEffect(() => {
      if (uploadFileDetails.headers) {
        // Reset options and selectedValues when a new file is uploaded
        setOptions(
          uploadFileDetails.headers.map((header) => ({
            label: header,
            value: header,
          }))
        );
        setSelectedValues({});
      }
    }, [uploadFileDetails]); // Runs whenever uploadFileDetails changes
    const handleChange = (field, value) => {
      setSelectedValues((prev) => ({
        ...prev,
        [field]: value,
      }));
    };
    const triggerFileInput = (type) => {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".csv";
      input.onchange = (e) => handleFileChange(e, type);
      input.click();
    };
    return (
      <Modal
        show={rootStore.showMatchModal}
        style={{ marginLeft: "100px" }}
        onHide={() => {
          if (rootStore.handleCloseModal()) {
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
          }
        }}
        centered
        size="lg"
        dialogClassName="custom-modal"
      >
        <Modal.Header // onClick={() => triggerFileInput('people')}
          style={{
            borderBottom: "none",
            paddingTop: "24px",
            paddingRight: "32px",
            paddingLeft: "32px",
            paddingBottom: "0px",
            marginBottom: "10px",
          }}
          className="justify-content-between"
        >
          <Modal.Title style={{ fontSize: "18px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div>Upload File</div>
              <span
                style={{
                  padding: "2px 6px",
                  fontSize: "12px",
                  fontWeight: "500",
                  backgroundColor: "rgb(245 247 251)",
                  color: "#384553",
                  border: "1px solid #C8CCD1",
                  borderRadius: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                For Company inclusion/exclusion record count should be below 50,000
              </span>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="custom-modal-close-button d-flex tw-justify-center tw-items-center"
            onClick={() => {
              rootStore.handleCloseModal();
              rootStore.dynamicFlags.set("popupType", "");
              setUploadFileDetails({
                exclusionName: "",
                fileName: "",
                type: "",
                field: "",
                csvData: [],
                headers: [],
              });
            }}
          >
            <img src={CloseImg} alt="close" width={20} height={20} />
          </button>
        </Modal.Header>
        <Modal.Body
          style={{
            paddingTop: "0px",
            paddingBottom: "0px",
            paddingRight: "32px",
            paddingLeft: "32px",
          }}
        >
          <Tabs
            activeKey={rootStore.modalStep}
            onSelect={(k) => rootStore.setModalStep(parseInt(k))}
            className="mb-3"
          >
            <Tab
              eventKey={0}
              title="1. Upload File"
              style={{ fontSize: "14px" }}
            >
              {rootStore.apiloader ? (
                <LinearProgress color="primary" />
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                      marginBottom: "16px",
                      marginTop: "20px",
                    }}
                  >
                    <label
                      style={{
                        color: "#252C34",
                        fontWeight: 500,
                        fontSize: "14px",
                        marginBottom: "4px",
                      }}
                    >
                      Name
                    </label>
                    <TextField
                      fullWidth
                      placeholder="E.g : Company List 24 Dec"
                      variant="outlined"
                      value={uploadFileDetails.exclusionName}
                      onChange={(e) => {
                        setUploadFileDetails((prev) => ({
                          ...prev,
                          exclusionName: e.target.value,
                        }));
                      }}
                      InputProps={{
                        style: { color: "#5E6976", fontSize: "14px" },
                      }}
                    />
                  </div>
                  <span>
                    Upload the file (
                    <a
                      onClick={download}
                      download
                      style={{
                        color: "#227AFF",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      Sample Files
                    </a>{" "}
                    )
                  </span>
                  <div
                    className={`fileUpload ${rootStore.isDragging ? "drag-active" : ""
                      }`}
                    onClick={triggerFileInput}
                    onDragEnter={rootStore.handleDragEnter}
                    onDragOver={rootStore.handleDragOver}
                    onDragLeave={rootStore.handleDragLeave}
                    onDrop={rootStore.handleDrop}
                    style={{ marginTop: "8px" }}
                  >
                    <img
                      src={fileupload}
                      alt="CSV Upload"
                      width="64px"
                      height="64px"
                      style={{
                        marginLeft: "46%",
                      }}
                    />
                    <p
                      className="mb-0 mt-2 "
                      style={{
                        color: "#252C34",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      Select a CSV file to import
                    </p>
                    <p className="dragtxt">or drag and drop it here</p>
                    <p className="dragtxt">
                      Supported format: .csv ( Max : 10 MB )
                    </p>
                    <input
                      type="file"
                      accept=".csv"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </div>
                </>
              )}
            </Tab>
            <Tab eventKey={1} title="2. Field Mapping" disabled={!uploadFileDetails.fileName || !uploadFileDetails.exclusionName}>
              {rootStore.apiloader ? (
                <LinearProgress color="primary" />
              ) : (
                <div className="mapping-container mt-3">
                  <label
                    style={{ marginBottom: ".5rem" }}
                    className="header-list"
                  >
                    Field Mapping
                    <span
                      className="tw-text-[12px] tw-bg-[#fde5f1] tw-border-[#e80271] tw-rounded-[8px] tw-px-[5px] tw-py-[6px] tw-pl-[0px]"
                      style={{ marginLeft: "0.5rem" }} // replaces &nbsp;
                    >
                      <InfoOutlinedIcon
                        style={{ marginLeft: 5, fontSize: 12, color: "#e80271" }}
                      />{" "}
                      Please select at least three fields, including Company Name, Address Line 1, and Postcode.
                    </span>
                  </label>

                  <div
                    style={{
                      border: "1px solid #E2E4E7",
                      borderRadius: "6px",
                      padding: "20px",
                    }}
                  >
                    {fieldSelect.map((field, index) => (
                      <div className="mapping-row" key={index}>
                        <Form.Label className="mapping-label">
                          {field.label}
                        </Form.Label>
                        <Form.Select
                          className="mapping-select"
                          required={
                            !Object.values(selectedValues).some(
                              (value) => value !== ""
                            )
                          }
                          value={selectedValues[field.value] || ""}
                          onChange={(e) =>
                            handleChange(field.value, e.target.value)
                          }
                        >
                          <option value="">Select matching column....</option>
                          {options.map((opt, idx) => (
                            <option
                              key={idx}
                              value={opt.value}
                              disabled={
                                Object.values(selectedValues).includes(
                                  opt.value
                                ) && selectedValues[field.value] !== opt.value
                              }
                            >
                              {opt.label}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    ))}
                  </div>
                </div>

              )}
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer
          style={{
            outline: "none",
            border: "none",
            paddingBottom: "10px",
            paddingRight: "32px",
            paddingLeft: "32px",
            paddingTop: "5px",
          }}
        >
          {rootStore.modalStep > 0 && (
            <Button
              style={{
                backgroundColor: "transparent",
                // border: "2px solid #255AF0",
                border: "none",
                borderRadius: "6px",
                color: "#255AF0",
              }}
              onClick={handlePrevious}
            >
              <ArrowBackIosIcon style={{ marginRight: 5, fontSize: 14 }} />
              Previous
            </Button>
          )}
          {rootStore.modalStep === 0 ? (
            <Button
              className="custom-login-button-primary"
              style={{
                width: "115px",
              }}
              onClick={handleNext}
              disabled={!uploadFileDetails.fileName || !uploadFileDetails.exclusionName}
            >
              Next <NavigateNextIcon style={{ marginLeft: 5, fontSize: 14 }} />
            </Button>
          ) : (
            <Button
              className="custom-login-button-primary"
              style={{
                width: "160px",
                fontSize: "14px",
              }}
              onClick={handleFormSubmit}
              disabled={Object.keys(selectedValues).length < 3}
            >
              Upload
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
);
export default MatchFieldsModal;
